import { Button, CardMedia, DrawerBody, DrawerFooter, LoadingButton, NotificationBadge, Typography, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { SubmitUpdatePickupLocationRequest } from '../../../api/oms/edit-pickup-location';
import '../../../styles/drawer.scss';
import { catchEditPickupLocationPostPageLoadError, catchGoBackButtonClick, trackConfirmPickupLocationChanges, } from '../../../utils/edit-pickup-location/analytics';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { EditPickupLocationStoreHoursAccordion } from './EditPickupLocationStoreHoursAccordion';
import { getLineItemIds } from './utils';
import { useOrderContext, useFulfillmentGroupContext, } from '../../../hooks/useContexts';
import { getFlowTypeValue } from '../util/OutOfStock';
import { getLineItemQuantity } from '../util/general';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { CustomImage } from '../../shared/CustomImage';
import { generateImageUrl } from '../../../utils/general';
export var EditPickupLocationConfirmation = function (_a) {
    var closeDrawer = _a.closeDrawer, suspendCartCheck = _a.suspendCartCheck, setIsStoreSelection = _a.setIsStoreSelection, setIsConfirmation = _a.setIsConfirmation, setIsSurvey = _a.setIsSurvey, setShowDrawerError = _a.setShowDrawerError, setIsLocationChangeConfirmed = _a.setIsLocationChangeConfirmed, setEditPickupLocationOrderIds = _a.setEditPickupLocationOrderIds, isIosMobile = _a.isIosMobile, selectedStoreData = _a.selectedStoreData;
    var _b = useFulfillmentGroupContext(), fulfillmentGroup = _b.fulfillmentGroup, fulfillmentGroupIndex = _b.fulfillmentGroupIndex, fulfillmentType = _b.fulfillmentType;
    var _c = useOrderContext(), currentDrawer = _c.currentDrawer, _d = _c.orderDetailsData, net = _d.net, emailId = _d.emailId, traceId = _d.traceId, _e = _d.grandTotalAmount, grandTotalAmount = _e === void 0 ? 0 : _e, _f = _d.subTotalAmount, subTotalAmount = _f === void 0 ? 0 : _f, _g = _d.taxTotalAmount, taxTotalAmount = _g === void 0 ? 0 : _g, _h = _d.shippingCharge, shippingCharge = _h === void 0 ? 0 : _h, _j = _d.deliveryCharge, deliveryCharge = _j === void 0 ? 0 : _j, fulfillmentGroups = _d.fulfillmentGroups, orderId = _c.orderId;
    var _k = useState(false), loading = _k[0], setLoading = _k[1]; // For Loading Button
    var goBack = function () {
        catchGoBackButtonClick();
        suspendCartCheck();
        setIsConfirmation(false);
        setIsStoreSelection(true);
        closeDrawer();
    };
    var onConfirmationSubmit = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        trackConfirmPickupLocationChanges(fulfillmentType);
        setLoading(true);
        var lineItems = (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) || [];
        var requestData = {
            cartId: (_b = (_a = selectedStoreData === null || selectedStoreData === void 0 ? void 0 : selectedStoreData.storeInfo) === null || _a === void 0 ? void 0 : _a.newOrder) === null || _b === void 0 ? void 0 : _b.cartId,
            orderId: orderId,
            oldStoreNumber: (_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _c === void 0 ? void 0 : _c.store) === null || _d === void 0 ? void 0 : _d.number,
            newStoreNumber: (_f = (_e = selectedStoreData === null || selectedStoreData === void 0 ? void 0 : selectedStoreData.storeInfo) === null || _e === void 0 ? void 0 : _e.newOrder) === null || _f === void 0 ? void 0 : _f.storeNumber,
            lineItems: getLineItemIds(lineItems),
            emailId: emailId,
            flowType: getFlowTypeValue(currentDrawer, FLOW_TYPES.EDIT_PICKUP_LOCATION),
            fulfillmentType: ((_g = convertedFulfillmentTypes(fulfillmentType)) === null || _g === void 0 ? void 0 : _g.toUpperCase()) || undefined,
            net: net,
        };
        SubmitUpdatePickupLocationRequest(requestData, traceId)
            .then(function (res) {
            setIsLocationChangeConfirmed(true);
            setEditPickupLocationOrderIds({
                orderIds: res.data.data,
                lineId: lineItems[0].lineId,
            });
            setIsConfirmation(false);
            setIsSurvey(true);
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e;
            setShowDrawerError(fulfillmentGroupIndex);
            closeDrawer();
            var errorCode = ((_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.code) === null || _e === void 0 ? void 0 : _e.toString()) || 'n/a';
            catchEditPickupLocationPostPageLoadError(errorCode);
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var newPickupDetails = function () { return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
        React.createElement("div", null,
            React.createElement(Typography, { variant: "h5" }, "New Pickup Details")),
        React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement(Typography, { weight: "bold" },
                selectedStoreData.storeData.storeName,
                " #",
                selectedStoreData.storeData.storeNumber),
            React.createElement(Typography, null, selectedStoreData.storeData.address.addressLine1),
            React.createElement(Typography, null,
                selectedStoreData.storeData.address.city,
                ",",
                ' ',
                selectedStoreData.storeData.address.stateCode,
                ' ',
                selectedStoreData.storeData.address.zipCode),
            React.createElement(EditPickupLocationStoreHoursAccordion, { store: selectedStoreData.storeData })))); };
    var ItemImage = function (item) {
        return useMemo(function () { return function () {
            var _a;
            return (React.createElement(CustomImage, { src: (_a = generateImageUrl(item)) !== null && _a !== void 0 ? _a : '', alt: item === null || item === void 0 ? void 0 : item.description, lazy: true, width: "48", height: "48" }));
        }; }, []);
    };
    var pickupItemImages = function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement("div", { className: "sui-mb-4 sui-mt-6" },
                    React.createElement(Typography, null, "Pick up today")),
                React.createElement("div", { className: "sui-flex sui-gap-5" }, (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.map(function (bopisItem, index) {
                    return (React.createElement(NotificationBadge, { key: index, variant: "strong", size: "small", color: "primary", badgeContent: getLineItemQuantity(bopisItem) },
                        React.createElement(CardMedia, { component: ItemImage(bopisItem) })));
                })))));
    };
    var updatedOrderDetails = function () {
        var _a;
        return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement(Typography, { variant: "h5" }, "Updated Order Summary"),
            !currentDrawer && (React.createElement(React.Fragment, null,
                React.createElement(AlertBanner, { status: "info" }, "The refund will be processed by your bank in 5-10 days."),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2" },
                    React.createElement(Typography, null, "Original Order"),
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                        React.createElement(Typography, { weight: "bold", "data-testid": "originalSubtotal" }, "Subtotal"),
                        React.createElement(Typography, { weight: "bold" },
                            "$",
                            subTotalAmount.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }))),
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                        React.createElement(Typography, null, "Pickup"),
                        React.createElement("div", null,
                            React.createElement(Typography, { color: "success" }, "FREE"))),
                    (fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.find(function (item) {
                        return ![
                            'BuyOnlinePickupInStore',
                            'BuyOnlineShipToStore',
                            'InStorePurchase',
                            'InStore',
                        ].includes(item.fulfillmentType);
                    })) ? (React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                        React.createElement(Typography, null, "Delivery"),
                        shippingCharge + deliveryCharge > 0 ? (React.createElement(Typography, null,
                            "$", (_a = (shippingCharge + deliveryCharge)) === null || _a === void 0 ? void 0 :
                            _a.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }))) : (React.createElement(Typography, { color: "success" }, "FREE")))) : null,
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                        React.createElement(Typography, { "data-testid": "originalSalesTax" }, "Sales Tax"),
                        React.createElement(Typography, null,
                            "$",
                            taxTotalAmount.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }))),
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-pb-3 sui-border-strongest sui-border-solid sui-border-b-1 sui-border-opacity-50" },
                        React.createElement(Typography, { weight: "bold" }, "Refund Total"),
                        React.createElement(Typography, { weight: "bold" },
                            "-$",
                            selectedStoreData.storeInfo.originalOrder.totals
                                .grandTotalAmount)),
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                        React.createElement(Typography, { weight: "bold", "data-testid": "remainingTotal" }, "Total"),
                        React.createElement(Typography, { weight: "bold" },
                            "$",
                            (grandTotalAmount -
                                Number(selectedStoreData.storeInfo.originalOrder.totals
                                    .grandTotalAmount)).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })))))),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2" },
                React.createElement(Typography, null, "New Order"),
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                    React.createElement(Typography, { weight: "bold" }, "Subtotal"),
                    React.createElement(Typography, { weight: "bold" },
                        "$",
                        selectedStoreData.storeInfo.newOrder.total.subTotalAmount)),
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                    React.createElement(Typography, null, "Pickup"),
                    React.createElement("div", null,
                        React.createElement(Typography, { color: "success" }, "FREE"))),
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-pb-3 sui-border-strongest sui-border-solid sui-border-b-1 sui-border-opacity-50" },
                    React.createElement(Typography, null, "Sales Tax"),
                    React.createElement(Typography, null,
                        "$",
                        selectedStoreData.storeInfo.newOrder.total.taxTotalAmount)),
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                    React.createElement(Typography, { weight: "bold" }, "Total"),
                    React.createElement(Typography, { weight: "bold" },
                        "$",
                        selectedStoreData.storeInfo.newOrder.total.grandTotalAmount)))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
                React.createElement(Typography, null, "Confirm changes to your pickup location if everything looks correct."),
                React.createElement(AlertBanner, { status: "info" },
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                        React.createElement(Typography, { weight: "bold" }, "What happens after you confirm changes?"),
                        currentDrawer === 'STORE_PICKUP_OPTION' ? (React.createElement(Typography, null, "We have canceled and refunded the items in your original Order # ".concat(selectedStoreData.storeInfo.originalOrder.orderId, "."))) : (React.createElement(Typography, null, "We'll cancel and refund the items in your original Order # ".concat(selectedStoreData.storeInfo.originalOrder.orderId, "."))),
                        React.createElement(Typography, null, "We'll place a new order and charge for the items you'll pick up at the new location."))),
                newPickupDetails(),
                pickupItemImages(),
                updatedOrderDetails())),
        React.createElement("div", null,
            React.createElement(DrawerFooter, { id: "drawer-footer-z-index-fix" },
                React.createElement("div", { className: "card-fix sui-pb-2" },
                    React.createElement(LoadingButton, { "data-testid": "confirm-changes-button", onClick: onConfirmationSubmit, loading: loading }, "Confirm Changes")),
                React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "secondary", onClick: function () {
                            goBack();
                        } }, "Cancel"))))));
};
